<div id="login-card" class="dx-card content">
  <dx-validation-group>
    <div class="login-header">
      <img class="logo" [height]="50" [src]="'/assets/images/tracagri_logo_color.svg'">
      <div class="text">Connectez-vous en utilisant vos identifiants.</div>
    </div>
    <div class="dx-field">
      <dx-text-box [(value)]="email" placeholder="Adresse e-mail" width="100%">
        <dx-validator>
          <dxi-validation-rule type="required"
                               message="Nous avons besoin d'une adresse e-mail pour vous connecter"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
    <div class="dx-field">
      <dx-text-box mode="password" [(value)]="password" placeholder="Mot de passe" width="100%">
        <dx-validator>
          <dxi-validation-rule type="required"
                               message="Nous avons besoin d'un mot de passe pour vous connecter"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
    <div class="dx-field">
      <dx-check-box [(value)]="rememberMe" text="Se souvenir de moi"></dx-check-box>
    </div>
    <div class="dx-field">
      <dx-button type="default" text="SE CONNECTER" (onClick)="onLoginClick($event)" width="100%"></dx-button>
    </div>
    <div class="dx-field">
      <a routerLink="/recovery">Mot de passe oublié?</a>
    </div>
    <!--<div class="dx-field">
      <dx-button type="normal" text="Create an account" width="100%"></dx-button>
    </div>-->
  </dx-validation-group>
</div>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.2)"
  [position]="{ of: '#login-card' }"
  [(visible)]="loadIndicatorVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
